
/**
 * 从缓存中读取用户信息
 * @returns 
 */
export default function getUserInfo () {
  let userInfo = {
    "userName": "",
    "email": "",
    "phoneNumber": "",
    "userId": "",
    "userNo": "",
    "userType": "",
    "clientId": ""
  }
  const { userData: userLocalStorage } = JSON.parse(localStorage.getItem('user')) || {}
  userInfo.userName = userLocalStorage.username
  userInfo.email = userLocalStorage.email
  userInfo.phoneNumber = userLocalStorage.phone
  // userInfo.userId = userLocalStorage.id
  userInfo.userId = userLocalStorage.username
  userInfo.userNo = ''
  userInfo.userType = ''
  userInfo.clientId = ''
  return userInfo
}